import { CONVERSATIONS_API } from "@/utils/apiUrl"
import backend from "@/utils/backend"
import * as types from "./mutation_types"


export const update = ({ commit }, data) => {
    const url = `${CONVERSATIONS_API}/${data?.id ?? 0}`

    commit(types.SET_SHOW_LOADING)
    commit(types.SET_NOT_UPDATED)
    commit(types.SET_RELOAD_CONVERSATION, false)

    backend({ url, data, method: "PUT" }).then(({ data }) => {
        commit(types.SET_UPDATE, data.data ?? data)
        commit(types.SET_IS_SUCCESS)
    commit(types.SET_RELOAD_CONVERSATION, true)

        commit(types.SET_MESSAGE, data.message ?? "Super")
        commit(types.SET_CURRENT_ITEM, data)
        commit(types.SET_IS_UPDATED)
    }).catch((err) => {
        commit(types.SET_UPDATE, null)
        commit(types.SET_RELOAD_CONVERSATION, false)

        commit(types.SET_NOT_UPDATED)
        commit(types.SET_IS_ERROR)
        commit(types.SET_SHOW_MESSAGE)
        commit(types.SET_MESSAGE, (err?.response?.message ?? err.message ?? err))
    }).finally(() => {
        commit(types.SET_SHOW_MESSAGE)
        commit(types.SET_HIDE_LOADING)

    })
}


export const closedConversation = ({ commit ,rootState,dispatch}) => {
    const url = `closeconvestation`

    const {show} = rootState.conversations
    const data = {conversation_id : show.item?.id ?? show.currentItem?.id ?? null}
    if(data.conversation_id == null){
        return ;
    }

    commit(types.SET_SHOW_LOADING)
    commit(types.SET_RELOAD_CONVERSATION, false)
    commit(types.SET_NOT_UPDATED)

    backend({ url, data, method: "POST" }).then(({ data }) => {

        commit(types.SET_IS_UPDATED)
        commit(types.SET_UPDATE, data.data ?? data)
        commit(types.SET_IS_SUCCESS)
        commit(types.SET_MESSAGE, data.message ?? "Super")
        commit(types.SET_CURRENT_ITEM, data)

        // Recharger la liste des conversations après clôture
        dispatch("conversations/list/getAll", null, {root: true})

    }).catch((err) => {
        commit(types.SET_NOT_UPDATED)
        commit(types.SET_UPDATE, null)

        commit(types.SET_IS_ERROR)
        commit(types.SET_SHOW_MESSAGE)
        commit(types.SET_MESSAGE, (err?.response?.message ?? err.message ?? err))
    }).finally(() => {
        commit(types.SET_SHOW_MESSAGE)
        commit(types.SET_HIDE_LOADING)

    })
}


export const mergeConversation = ({ commit ,rootState,dispatch}) => {
    const url = `conversationMerge`

    const {show} = rootState.conversations
    const data = {conversation_id : show.item?.id ?? show.currentItem?.id ?? null}
    if(data.conversation_id == null){
        return ;
    }

    commit(types.SET_SHOW_LOADING)
    commit(types.SET_RELOAD_CONVERSATION, false)
    commit(types.SET_NOT_UPDATED)

    backend({ url, data, method: "POST" }).then(({ data }) => {

        commit(types.SET_IS_UPDATED)
        commit(types.SET_UPDATE, data.data ?? data)
        commit(types.SET_IS_SUCCESS)
        commit(types.SET_MESSAGE, data.message ?? "Super")
        commit(types.SET_CURRENT_ITEM, data)

        // Recharger la liste des conversations après ignore
        dispatch("conversations/list/getAll", null, {root: true})

    }).catch((err) => {
        commit(types.SET_NOT_UPDATED)
        commit(types.SET_UPDATE, null)

        commit(types.SET_IS_ERROR)
        commit(types.SET_SHOW_MESSAGE)
        commit(types.SET_MESSAGE, (err?.response?.message ?? err.message ?? err))
    }).finally(() => {
        commit(types.SET_SHOW_MESSAGE)
        commit(types.SET_HIDE_LOADING)

    })
}


export const assignedConversation = ({ commit ,rootState,dispatch }) => {
    const url = `takecharge`;
    const {show} = rootState.conversations
    const data = {conversation_id : show.item?.id ?? show.currentItem?.id ?? null}
    if(data.conversation_id == null){
        return ;
    }

    commit(types.SET_SHOW_LOADING)
    commit(types.SET_RELOAD_CONVERSATION, true)
    commit(types.SET_NOT_UPDATED)


    backend({ url, data, method: "POST" }).then(({ data }) => {
        const conversationData = data.data ?? data

        console.log('🔍 DEBUG assignedConversation - conversationData:', conversationData)
        console.log('🔍 DEBUG assignedConversation - agent_id:', conversationData?.agent_id)
        console.log('🔍 DEBUG assignedConversation - agent object:', conversationData?.agent)

        // Mettre à jour le module update
        commit(types.SET_UPDATE, conversationData)
        commit(types.SET_CURRENT_ITEM, conversationData)
        commit(types.SET_IS_SUCCESS)
        commit(types.SET_MESSAGE, data.message ?? "Super")
        commit(types.SET_IS_UPDATED)

        // Mettre à jour directement le module show pour éviter le rechargement
        dispatch("conversations/show/updateConversationDirect", conversationData, {root: true})

    }).catch((err) => {
        commit(types.SET_UPDATE, null)
        commit(types.SET_NOT_UPDATED)
        commit(types.SET_IS_ERROR)
        commit(types.SET_SHOW_MESSAGE)
        commit(types.SET_MESSAGE, (err?.response?.message ?? err.message ?? err))
    }).finally(() => {
        commit(types.SET_SHOW_MESSAGE)
        commit(types.SET_HIDE_LOADING)

    })
}



export const resetData = ({ commit }) => {
    commit(types.RESET)
}



